import { Checkbox } from "antd";
import styled from "styled-components";

export const EventIdsCheckboxGroup = styled(Checkbox.Group)`
  display: block;

  .ant-checkbox-group-item {
    margin-left: 0;
  }
`;

export const EventDropDownWrapper = styled.div`
  button {
    text-align: left;
  }
`;
